import { gql } from '@apollo/client';

import TASK_FRAGMENT from '../../gql/TaskFragment.graphql';
import TASK_TEMPLATE_FRAGMENT from '../../gql/TaskTemplateFragment.graphql';

export const SUBTASK_UPDATE_POSITION = gql`
  mutation SubTaskUpdatePosition($input: SubTaskUpdatePositionInput!) {
    subTaskUpdatePosition(input: $input) {
      subTask {
        __typename
        id
        position
        task {
          __typename
          ...TaskFragment
        }
      }
      errors {
        message
        error
      }
    }
  }
  ${TASK_FRAGMENT}
`;

export const SUBTASK_TEMPLATE_UPDATE_POSITION = gql`
  mutation SubTaskTemplateUpdatePosition(
    $input: SubTaskTemplateUpdatePositionInput!
  ) {
    subTaskTemplateUpdatePosition(input: $input) {
      subTaskTemplate {
        __typename
        id
        position
        taskTemplate {
          __typename
          ...TaskTemplateFragment
        }
      }
      errors {
        message
        error
      }
    }
  }
  ${TASK_TEMPLATE_FRAGMENT}
`;

export const SUBTASK_CREATE = gql`
  mutation SubTaskCreate($input: SubTaskCreateInput!) {
    subTaskCreate(input: $input) {
      subTask {
        __typename
        id
        answerType
        label
        task {
          __typename
          ...TaskFragment
        }
      }
      errors {
        message
        error
      }
    }
  }
  ${TASK_FRAGMENT}
`;

export const SUBTASK_UPDATE = gql`
  mutation SubtaskUpdate($input: SubTaskUpdateInput!) {
    subTaskUpdate(input: $input) {
      errors {
        error
        message
      }
      subTask {
        __typename
        id
        label
        answerOptions
        answerChoices
      }
    }
  }
`;

export const SUBTASK_UPDATE_ANSWER_CHOICES = gql`
  mutation SubTaskUpdateAnswerChoices($input: SubTaskUpdateAnswerChoicesInput!) {
    subTaskUpdateAnswerChoices(input: $input) {
      errors {
        error
        message
      }
      subTask {
        id
        answerChoices
        answerText
        __typename
        task {
          id
          completed
          __typename
        }
      }
    }
  }
`;

export const SUBTASK_DELETE = gql`
  mutation SubtaskDelete($input: SubTaskDeleteInput!) {
    subTaskDelete(input: $input) {
      errors {
        error
        message
      }
      deletedId
    }
  }
`;
